<template>
    <p>&nbsp;</p>
</template>
<script>
import { apiUrl } from "../vars";
import { appUrl } from "../vars";

export default {
  created() {
    let o = {
      email: this.$route.query.email,
      token: this.$route.query.token
    };

    axios
      .post(apiUrl + "/auth/activate", o)
      .then(response => {
        let token = response.data.token;

        if (token) {
          console.log("token");
          let d = "home";
          let t = token.split(".");
          let i = btoa(t[0])
            .split("")
            .reverse()
            .join("");
          let w = btoa(response.statusText);
          let v = btoa(response.message);
          let u = btoa(t[1])
            .split("")
            .reverse()
            .join("");
          let k = btoa(response.data.status);
          let r = btoa(t[2])
            .split("")
            .reverse()
            .join("");
          let x = btoa(d);

          window.location =
            appUrl +
            "/sso?gw328DK2=" +
            i +
            "&ADHXf2x3=" +
            w +
            "&xftBIGAC=" +
            v +
            "&BGxYZ4xu=" +
            u +
            "&PeIQ306e=" +
            k +
            "&o2d8IWFA=" +
            r +
            "&bPkIzKkT=" +
            x;
        }

        if (!token) {
          this.$router.push({
            name: "home",
            params: {
              message:
                "Falha ao ativar o registo. Se o problema persistir, entre em contato com nosso suporte."
            }
          });
        }
      })
      .catch(error => {
        console.log(error);
      });
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/Activate.vue